import ResetGateway from './resetGateway/PluginSetup';
import InstallGateway from './installGateway/InstallGateway';
import RingTag from './ringTag/PluginSetup';
import LogUpload from './logUpload/PluginSetup';
import ConvertLocatorToGateway from './convertLocatorToGateway';
import KeyTagPairing from './keyTagPairing/keyTagPairing';
export default {
  install: molten => {
    molten.addPlugin('Action', InstallGateway);
    molten.addPlugin('Action', KeyTagPairing);
    molten.addPlugin('Action', ConvertLocatorToGateway);
    ResetGateway.install(molten);
    RingTag.install(molten);
    LogUpload.install(molten);
  }
};